// 2026-09-24 - FormuLearning - 보고서 블록 미리보기 (이슈 #59)
// 파일 위치: frontend/src/features/step7/ReportBlocks.tsx
//
// 서버 docx 렌더러(backend/app/report/docx_render.py)와 같은 블록을 화면에 그린다(설계 D-6).

import type { ReportBlock } from '../../api/report'

export default function ReportBlocks({ blocks }: { blocks: ReportBlock[] }) {
  return (
    <div className="flex flex-col gap-2">
      {blocks.map((b, i) => <Block key={i} b={b} />)}
    </div>
  )
}

function Block({ b }: { b: ReportBlock }) {
  switch (b.type) {
    case 'heading':
      return <p className={`${b.level <= 3 ? 'text-xs' : 'text-[11px]'} mt-1 font-semibold text-text-primary`}>{b.text}</p>
    case 'paragraph':
      return <p className="whitespace-pre-wrap text-[11px] leading-relaxed text-text-body">{b.text}</p>
    case 'bullets':
      return (
        <ul className="list-disc pl-5 text-[11px] text-text-body">
          {b.items.map((it, i) => <li key={i}>{it}</li>)}
        </ul>
      )
    case 'summary':
      return (
        <div className="rounded px-3 py-2" style={{ background: 'var(--bg-chip-teal)' }}>
          <p className="mb-1 text-[10px] font-semibold" style={{ color: 'var(--color-accent-teal)' }}>[{b.label}]</p>
          <p className="whitespace-pre-wrap text-[11px] leading-relaxed text-text-body">{b.ko || b.en}</p>
        </div>
      )
    case 'note':
      return <p className="text-[10px] italic text-text-secondary">※ {b.text}</p>
    case 'table':
      return (
        <div className="overflow-x-auto">
          {b.caption && <p className="mb-1 text-[10px] font-semibold text-text-secondary">{b.caption}</p>}
          <table className="w-full border-collapse text-[10px]">
            <thead>
              <tr>
                {b.columns.map((c, i) => (
                  <th key={i} className="whitespace-nowrap border px-2 py-1 text-left font-semibold text-text-body"
                    style={{ borderColor: 'var(--border-subtle)', background: 'var(--color-bg-input)' }}>{c}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {b.rows.map((r, i) => (
                <tr key={i}>
                  {r.map((v, j) => (
                    <td key={j} className="border px-2 py-1 text-text-body" style={{ borderColor: 'var(--border-subtle)' }}>{v}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
    default:
      return null
  }
}
